import Vue from 'vue';

var script = Vue.extend({
    name: 'MaintenanceChecker',
    props: {
        checkedParts: {
            type: Array,
            required: true,
        },
        isInMaintenance: {
            type: Function,
            required: true,
        }
    },
    watch: {
        arePartsInMaintenance: function (value) {
            if (value) {
                this.closeOpenedEvents();
                this.scrollToTop();
            }
        },
    },
    computed: {
        arePartsInMaintenance: function () {
            var _this = this;
            return this.checkedParts.some(function (part) { return _this.isInMaintenance(part); });
        },
    },
    methods: {
        closeOpenedEvents: function () {
            this.$router.push({ path: this.$route.path });
        },
        scrollToTop: function () {
            window.scrollTo(0, 0);
        },
    },
});

export default script;
